// Single source of truth for public (no-auth) routes.
// Imported by App.js (route definitions) and lib/api.js (interceptor whitelist).
// When you add a new public route, add it here and reference the constant in App.js.

export const PUBLIC_PATHS = [
  { path: "/login", prefix: true },
  { path: "/signup", prefix: false },
  { path: "/quote", prefix: false },
  { path: "/app/quote", prefix: false },
  { path: "/public/quote", prefix: false },
  { path: "/survey", prefix: false },
  { path: "/app/survey", prefix: false },
  { path: "/public/survey", prefix: false },
  { path: "/track", prefix: false },
  { path: "/t/", prefix: true },
  { path: "/sc/signup", prefix: false },
  { path: "/get-quote", prefix: false },
];

// Used by lib/api.js to decide whether to skip the 401 → /login redirect
export const PUBLIC_PATH_PREFIXES = PUBLIC_PATHS.map((p) => p.path);

export function isPublicPath(pathname) {
  return PUBLIC_PATH_PREFIXES.some((p) => pathname.startsWith(p));
}
